module.exports = __webpack_public_path__ + "img/DE03694.e4fb5214.png";